import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedPipelineEngine } from '../ui/AnimatedPipelineEngine';
import { AnimatedGradientBackground } from '../ui/AnimatedGradientBackground';
export function AnimatedEngineSection() {
  return <AnimatedGradientBackground className="py-16 md:py-24" data-id="element-72">
      <div className="container-custom" data-id="element-73">
        <motion.div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-74">
          <div className="inline-block bg-mint/10 text-mint px-4 py-2 rounded text-sm font-semibold mb-6" data-id="element-75">
            The System
          </div>
          <h2 className="text-white mb-6" data-id="element-76">
            Three Engines. One Complete System.
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-77">
            Watch your pipeline come alive. Candidates flow through a
            structured, intentional process designed to deliver consistent,
            qualified hires.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-78">
          <AnimatedPipelineEngine className="mb-12 md:mb-16" data-id="element-79" />
        </motion.div>

        <motion.div className="max-w-4xl mx-auto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} data-id="element-80">
          <div className="grid md:grid-cols-3 gap-6 text-center" data-id="element-81">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-82">
              <div className="text-3xl font-bold text-mint mb-2" data-id="element-83">20-50</div>
              <p className="text-gray-400 text-sm" data-id="element-84">
                Qualified interviews per month
              </p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-85">
              <div className="text-3xl font-bold text-mint mb-2" data-id="element-86">70%+</div>
              <p className="text-gray-400 text-sm" data-id="element-87">Interview-to-hire rate</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-88">
              <div className="text-3xl font-bold text-mint mb-2" data-id="element-89">45%</div>
              <p className="text-gray-400 text-sm" data-id="element-90">
                Better retention than industry avg
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div className="text-center mt-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-91">
          <a href="/how-it-works" className="inline-block bg-mint hover:bg-mint-dark text-deep-blue font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-92">
            See How Each Engine Works →
          </a>
        </motion.div>
      </div>
    </AnimatedGradientBackground>;
}